// extracted by mini-css-extract-plugin
export default {"region-overlay":"dHXbKO","region-modal":"WMvlhW"};